// This file is generated by the Webpack next-flight-loader.
import { registerClientReference } from "react-server-dom-webpack/server";
export const IncidentsLinks = registerClientReference(
function() { throw new Error("Attempted to call IncidentsLinks() from the server but IncidentsLinks is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
"/app/components/navbar/IncidentLinks.tsx",
"IncidentsLinks",
);